// Static UI strings (menu, buttons, form labels) — not managed by CMS
export const ui = {
  nav: {
    home: { it: "Home", en: "Home" },
    about: { it: "Chi siamo", en: "About" },
    services: { it: "Servizi", en: "Services" },
    artists: { it: "Artisti", en: "Artists" },
    testimonials: { it: "Testimonianze", en: "Testimonials" },
    contacts: { it: "Contatti", en: "Contact" },
    landing1: { it: "Landing 1", en: "Landing 1" },
    landing2: { it: "Landing 2", en: "Landing 2" },
    apply: { it: "Candidati", en: "Apply" },
  },
  form: {
    name: { it: "Nome e cognome", en: "Full name" },
    email: { it: "Email", en: "Email" },
    phone: { it: "Cellulare", en: "Mobile phone" },
    message: { it: "Messaggio", en: "Message" },
    artist_name: { it: "Nome d'arte", en: "Stage name" },
    genre: { it: "Genere musicale", en: "Genre" },
    instagram: { it: "Instagram", en: "Instagram" },
    monthly_listeners: { it: "Ascoltatori mensili Spotify", en: "Monthly Spotify listeners" },
    goal: { it: "Obiettivo principale", en: "Main goal" },
    budget: { it: "Budget mensile disponibile", en: "Available monthly budget" },
    submit: { it: "Invia candidatura", en: "Send application" },
    submit_contact: { it: "Invia messaggio", en: "Send message" },
    next: { it: "Avanti", en: "Next" },
    back: { it: "Indietro", en: "Back" },
    step: { it: "Passo", en: "Step" },
    of: { it: "di", en: "of" },
    success: { it: "Grazie! Ti ricontatteremo entro 48 ore.", en: "Thanks! We'll reach out within 48 hours." },
    error: { it: "Qualcosa è andato storto. Riprova.", en: "Something went wrong. Try again." },
  },
  admin: {
    login: { it: "Accedi al CMS", en: "Sign in to CMS" },
    logout: { it: "Esci", en: "Log out" },
    dashboard: { it: "Dashboard", en: "Dashboard" },
    artists: { it: "Artisti", en: "Artists" },
    testimonials: { it: "Testimonianze", en: "Testimonials" },
    content: { it: "Contenuti", en: "Content" },
    leads: { it: "Lead", en: "Leads" },
    save: { it: "Salva", en: "Save" },
    delete: { it: "Elimina", en: "Delete" },
    edit: { it: "Modifica", en: "Edit" },
    add: { it: "Aggiungi", en: "Add" },
    cancel: { it: "Annulla", en: "Cancel" },
    export_csv: { it: "Esporta CSV", en: "Export CSV" },
  },
  common: {
    scroll: { it: "Scorri", en: "Scroll" },
    read_more: { it: "Scopri di più", en: "Read more" },
    view_all: { it: "Vedi tutti", en: "View all" },
    listen_on: { it: "Ascolta su", en: "Listen on" },
    follow_on: { it: "Segui su", en: "Follow on" },
  },
};

export const s = (path, lang) => {
  const parts = path.split(".");
  let node = ui;
  for (const p of parts) {
    node = node?.[p];
    if (!node) return path;
  }
  return node[lang] || node.it || path;
};
